import LoLExamRoomAppBar from './LoLExamRoomAppBar';

export default LoLExamRoomAppBar;
